import { useState, useEffect, useCallback } from 'react';
import { postService, Post } from '../services/postService';

export function useFeed(userId: string | null) {
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    setError(null);
    try {
      setPosts(await postService.getFeed());
    } catch {
      setError('Failed to load feed');
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => { refresh(); }, [refresh]);

  const addPost = useCallback((post: Post) => {
    setPosts(prev => [post, ...prev]);
  }, []);

  const removePost = useCallback(async (postId: string) => {
    await postService.deletePost(postId);
    setPosts(prev => prev.filter(p => p.postId !== postId));
  }, []);

  return { posts, loading, error, refresh, addPost, removePost };
}
